import React, { Component } from 'react';
import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'

import { Container } from '@material-ui/core';

const classes = makeStyles((theme) => ({
   paper: {
     marginTop: theme.spacing(8),
     display: 'flex',
     flexGrow: 1,
     flexDirection: 'column',
     alignItems: 'center',
   },
   title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
}));

document.title = 'Frota UFSM'
document.logo=''

class Viagem extends Component {
   
  
 render(){
return(
 
<Container >
      <div id="cabeça" >
      <Principal/>
      
      
      </div>
      
      <Container  maxWidth='md'>
      <div id="corpo" mt={3} className={classes.paper} align="center" >

      <Typography className={classes.title} variant="h5" noWrap align="center">
            Viagem
          </Typography>
          <text > Para iníciar selecione uma opção no menu, que fica no canto superior a esquerda.
            
          </text>
          
      </div>
       </Container>
  
       <Box mt={3}>
          <Copyright/>
       </Box>
   
   
   </Container>
)}

}

 
 
export default Viagem;
